import React, { useMemo } from 'react'
import Avatar from 'react-avatar';
import { useSelector } from 'react-redux'
import { planPeriod } from 'slices/membership/selectors';
import { RootState } from 'store'
import { textToTitleCase } from 'utils/helpers';

const SidebarFooter = () => {

    const user = useSelector((state: RootState) => state.auth.user);
    const selectedAgency = useSelector((state: RootState) => state.auth.selectedAgency);

    const { membership: membershipData, subscription_plans: plansData } = useSelector((state: RootState) => state.membershipState);
    const activePlan = membershipData?.data?.active_plan ?? null;

    const { planDaysLeft, planDaysCompletedPercentage, endsIn } = useSelector(planPeriod);

    const isTrialPlan = useMemo(() => {
        return !!(activePlan?.plan_frequency?.is_trial);
    }, [activePlan]);

    return (
        <div className='sidebar-footer'>
            {
                isTrialPlan &&
                <div className="trial-period-box">
                    <span className="trial-plan-name">
                        {activePlan?.plan?.name}  •  FREE TRIAL
                    </span>
                    <div className="d-flex flex-column gap-2">
                        <span className='trial-days-left'>
                            {
                                !!(endsIn) ?
                                    endsIn
                                    :
                                    (planDaysLeft > 0 ? `${planDaysLeft} day${planDaysLeft !== 1 ? 's' : ''} left` : 'Trial Ended')
                            }
                        </span>
                        <div className="trial-period-progress">
                            <div className="trial-period-progress-completed" style={{ width: `${planDaysCompletedPercentage}%`, backgroundColor: (planDaysLeft ?? 0) > 3 ? '#3CC0F8' : (planDaysLeft ?? 0) > 1 ? '#F47133' : '#FF343E' }}></div>
                        </div>
                    </div>
                </div>
            }
            <div className='user-profile'>
                <Avatar size='32' maxInitials={1} round={'50%'} name={user?.name} />
                <div className="d-flex flex-column">
                    <span className="user-name text-truncate">{user?.name}</span>
                    <span className="user-access-type">{textToTitleCase(selectedAgency?.type ?? '')}</span>
                </div>
            </div>
        </div>
    )
}

export default SidebarFooter